import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    vaccineStockManagement: {
        id: 'iaso.polio.menu.vaccineStockManagement',
        defaultMessage: 'Stock management',
    },
    country: {
        id: 'iaso.polio.table.label.country',
        defaultMessage: 'Country',
    },
    vaccine: {
        id: 'iaso.polio.vaccine',
        defaultMessage: 'Vaccine',
    },
    obrName: {
        id: 'iaso.polio.form.label.obrName',
        defaultMessage: 'OBR Name',
    },
    campaign: {
        id: 'iaso.polio.form.label.obrName',
        defaultMessage: 'OBR Name',
    },
    actions: {
        defaultMessage: 'Action(s)',
        id: 'iaso.label.actions',
    },
    edit: {
        id: 'iaso.label.edit',
        defaultMessage: 'Edit',
    },
    search: {
        defaultMessage: 'Search',
        id: 'iaso.search',
    },
    clear: {
        id: 'iaso.label.clear',
        defaultMessage: 'Clear',
    },
    vialsDestroyed: {
        id: 'iaso.label.vialsDestroyed',
        defaultMessage: 'Vials destroyed',
    },
    stockUnusableVials: {
        id: 'iaso.label.stockUnusableVials',
        defaultMessage: 'Stock of unusable vials',
    },
    stockUsableVials: {
        id: 'iaso.label.stockUsableVials',
        defaultMessage: 'Stock of usable vials',
    },
    unusableVials: {
        id: 'iaso.label.unusableVials',
        defaultMessage: 'Unusable vials',
    },
    usableVials: {
        id: 'iaso.label.usableVials',
        defaultMessage: 'Usable vials',
    },
    unusable: {
        id: 'iaso.label.unusable',
        defaultMessage: 'Unusable',
    },
    usable: {
        id: 'iaso.label.usable',
        defaultMessage: 'Usable',
    },
    vialsUsed: {
        id: 'iaso.label.vialsUsed',
        defaultMessage: 'Vials used',
    },
    vialsReceived: {
        id: 'iaso.label.vialsReceived',
        defaultMessage: 'Vials received',
    },
    doses_out: {
        id: 'iaso.label.doses_out',
        defaultMessage: 'Doses OUT',
    },
    doses_in: {
        id: 'iaso.label.doses_in',
        defaultMessage: 'Doses IN',
    },
    vials_out: {
        id: 'iaso.label.vials_out',
        defaultMessage: 'Vials OUT',
    },
    vials_in: {
        id: 'iaso.label.vials_in',
        defaultMessage: 'Vials IN',
    },
    action: {
        id: 'iaso.label.action',
        defaultMessage: 'Action',
    },
    date: {
        defaultMessage: 'Date',
        id: 'iaso.label.date',
    },
    unusableDoses: {
        id: 'iaso.label.unusableDoses',
        defaultMessage: 'Unusable doses',
    },
    usableDoses: {
        id: 'iaso.label.usableDoses',
        defaultMessage: 'Usable doses',
    },
    stockBalance: {
        id: 'iaso.label.stockBalance',
        defaultMessage: 'Stock balance',
    },
    stockDetails: {
        id: 'iaso.label.stockDetails',
        defaultMessage: 'Stock details',
    },
    formA: {
        id: 'iaso.polio.label.formA',
        defaultMessage: 'Form A',
    },
    destructionReports: {
        id: 'iaso.polio.label.destructionReports',
        defaultMessage: 'Destruction reports',
    },
    incidentReports: {
        id: 'iaso.polio.label.incidentReports',
        defaultMessage: 'Incident reports',
    },
    stockVariation: {
        id: 'iaso.polio.label.stockVariation',
        defaultMessage: 'Stock variation',
    },
    forma_vials_used: {
        id: 'iaso.polio.label.forma_vials_used',
        defaultMessage: 'Vials used',
    },
    forma_vials_missing: {
        id: 'iaso.polio.label.forma_vials_missing',
        defaultMessage: 'Vials missing',
    },
    forma_unusable_vials: {
        id: 'iaso.polio.label.forma_unusable_vials',
        defaultMessage: 'Unusable vials',
    },
    lot_numbers_for_usable_vials: {
        id: 'iaso.polio.label.lot_numbers_for_usable_vials',
        defaultMessage: 'Lot numbers for usable vials',
    },
    report_date: {
        id: 'iaso.polio.label.report_date',
        defaultMessage: 'Date of report',
    },
    form_a_reception_date: {
        id: 'iaso.polio.label.form_a_reception_date',
        defaultMessage: 'Form A reception (RRT)',
    },
    unusable_vials: {
        id: 'iaso.polio.label.unusable_vials',
        defaultMessage: 'Unusable vials',
    },
    usable_vials: {
        id: 'iaso.polio.label.usable_vials',
        defaultMessage: 'Usable vials',
    },
    vials_destroyed: {
        id: 'iaso.polio.label.vials_destroyed',
        defaultMessage: 'Vials destroyed',
    },
    incident_report_received_by_rrt: {
        id: 'iaso.polio.label.incident_report_received_by_rrt',
        defaultMessage: 'Incident report received by RRT',
    },
    rrt_destruction_report_reception_date: {
        id: 'iaso.polio.label.rrt_destruction_report_reception_date',
        defaultMessage: 'Destruction report received by RRT',
    },
    formaReports: {
        id: 'iaso.polio.label.formA',
        defaultMessage: 'Form A',
    },
    destruction: {
        id: 'iaso.polio.label.destruction',
        defaultMessage: 'Destruction',
    },
    incident: {
        id: 'iaso.polio.label.incident',
        defaultMessage: 'Incident',
    },
    lot_numbers: {
        id: 'iaso.polio.label.lot_numbers',
        defaultMessage: 'Lot numbers',
    },
    physical_inventory_add: {
        id: 'iaso.polio.label.physical_inventory_add',
        defaultMessage: 'Add to Physical inventory',
    },
    physical_inventory_remove: {
        id: 'iaso.polio.label.physical_inventory_remove',
        defaultMessage: 'Remove from Physical inventory',
    },
    stealing: {
        id: 'iaso.polio.label.stealing',
        defaultMessage: 'Theft',
    },
    return: {
        id: 'iaso.polio.label.return_to_supplier',
        defaultMessage: 'Return to supplier',
    },
    missing: {
        id: 'iaso.polio.label.missing',
        defaultMessage: 'Missing',
    },
    vaccine_expired: {
        id: 'iaso.polio.label.vaccine_expired',
        defaultMessage: 'Vaccine expired',
    },
    vvm_reached_discard_point: {
        id: 'iaso.polio.label.vvm_reached_discard_point',
        defaultMessage: 'VM reached discard point',
    },
    broken: {
        id: 'iaso.polio.label.broken',
        defaultMessage: 'Broken',
    },
    unreadable_label: {
        id: 'iaso.polio.label.unreadable_label',
        defaultMessage: 'Unreadable label',
    },
    missing_droppers: {
        id: 'iaso.polio.label.missing_droppers',
        defaultMessage: 'Missing droppers',
    },
    stockCorrection: {
        id: 'iaso.polio.label.stockCorrection',
        defaultMessage: 'Stock correction',
    },
    save: {
        id: 'iaso.label.save',
        defaultMessage: 'Save',
    },
    cancel: {
        id: 'iaso.label.cancel',
        defaultMessage: 'Cancel',
    },
    create: {
        defaultMessage: 'Create',
        id: 'iaso.label.create',
    },
    positiveInteger: {
        id: 'iaso.polio.form.validator.error.positiveInteger',
        defaultMessage: 'Please use a positive integer',
    },
    positiveNumber: {
        id: 'iaso.polio.form.validator.error.positiveNumber',
        defaultMessage: 'Please use a positive number',
    },
    invalidDate: {
        id: 'iaso.polio.form.invalidDate',
        defaultMessage: 'Date is invalid',
    },
    requiredField: {
        id: 'iaso.forms.error.fieldRequired',
        defaultMessage: 'This field is required',
    },
    lotNumberError: {
        id: 'iaso.polio.form.error.lotNumberError',
        defaultMessage: 'Please input numbers separated by a comma',
    },
    view: {
        defaultMessage: 'View',
        id: 'iaso.label.view',
    },
    countryBlock: {
        defaultMessage: 'Country block',
        id: 'iaso.polio.label.countryBlock',
    },
    seeSupplyChainForCountry: {
        id: 'iaso.polio.label.seeSupplyChainForCountry',
        defaultMessage: 'See supply chain for country',
    },
    deleteStockWarning: {
        id: 'iaso.polio.label.deleteStockWarning',
        defaultMessage: 'Are you sure you want to delete this vaccine stock?',
    },
    deleteTextBody: {
        id: 'iaso.label.deleteText',
        defaultMessage: 'This operation cannot be undone.',
    },
    deleteFormA: {
        id: 'iaso.polio.label.deleteFormA',
        defaultMessage: 'Delete Form A',
    },
    deleteFormAWarning: {
        id: 'iaso.polio.label.deleteFormAWarning',
        defaultMessage: 'Are you sure you want to delete this Form A ?',
    },
    deleteDestruction: {
        id: 'iaso.polio.label.deleteDestruction',
        defaultMessage: 'Delete Destruction Report',
    },
    deleteDestructionWarning: {
        id: 'iaso.polio.label.deleteDestructionWarning',
        defaultMessage:
            'Are you sure you want to delete this destruction report ?',
    },
    deleteIncident: {
        id: 'iaso.polio.label.deleteIncident',
        defaultMessage: 'Delete Incident Report',
    },
    deleteIncidentWarning: {
        id: 'iaso.polio.label.deleteIncidentWarning',
        defaultMessage:
            'Are you sure you want to delete this incident report ?',
    },
    deleteEarmarked: {
        id: 'iaso.polio.label.deleteEarmarked',
        defaultMessage: 'Delete Earmarked Stock',
    },
    deleteEarmarkedWarning: {
        id: 'iaso.polio.label.deleteEarmarkedWarning',
        defaultMessage:
            'Are you sure you want to delete this earmarked stock ?',
    },
    title: {
        id: 'iaso.polio.label.title',
        defaultMessage: 'Title',
    },
    comment: {
        id: 'iaso.polio.label.comment',
        defaultMessage: 'Comment',
    },
    movement: {
        id: 'iaso.polio.label.movement',
        defaultMessage: 'Movement',
    },
    vialsOut: {
        id: 'iaso.polio.label.vialsOut',
        defaultMessage: 'Vials Out',
    },
    usableVialsIn: {
        id: 'iaso.polio.label.usableVialsIn',
        defaultMessage: 'Usable Vials In',
    },
    unusableVialsIn: {
        id: 'iaso.polio.label.unusableVialsIn',
        defaultMessage: 'Unusable Vials In',
    },
    plainMovement: {
        id: 'iaso.incident.plainMovement',
        defaultMessage:
            'Usable vials out: {movement}, Unusable vials in: {movement}',
    },
    missingMovement: {
        id: 'iaso.incident.missingMovement',
        defaultMessage: 'Usable vials out: {movement}',
    },
    inventoryUsableMovement: {
        id: 'iaso.incident.inventoryUsableMovement',
        defaultMessage: 'Usable vials in: {movement}',
    },
    inventoryUnusableMovement: {
        id: 'iaso.incident.inventoryUnusableMovement',
        defaultMessage: 'Unusable vials in: {movement}',
    },
    document: {
        id: 'iaso.polio.label.document',
        defaultMessage: 'Document',
    },
    round: {
        id: 'iaso.polio.label.round',
        defaultMessage: 'Round',
    },
    download: {
        defaultMessage: 'Download',
        id: 'iaso.polio.label.download',
    },
    stockToModify: {
        id: 'iaso.polio.label.stockToModify',
        defaultMessage: 'Stock to modify',
    },
    earmarked: {
        id: 'iaso.polio.label.earmarked',
        defaultMessage: 'Earmarked',
    },
    earmarked_doses: {
        id: 'iaso.polio.label.earmarked_doses',
        defaultMessage: 'Earmarked doses',
    },
    earmarked_vials: {
        id: 'iaso.polio.label.earmarked_vials',
        defaultMessage: 'Earmarked vials',
    },
    created: {
        id: 'iaso.label.created_at',
        defaultMessage: 'Created',
    },
    used: {
        id: 'iaso.label.used',
        defaultMessage: 'Used',
    },
    returned: {
        id: 'iaso.label.returned',
        defaultMessage: 'Returned',
    },
    temporary_campaign_name: {
        id: 'iaso.polio.label.temporary_campaign_name',
        defaultMessage: 'Temporary campaign name',
    },
    duplicate_destruction: {
        id: 'iaso.polio.label.duplicate_destruction',
        defaultMessage:
            'A destruction report with the same date and unusable vials destroyed already exists',
    },
    customObrName: {
        id: 'iaso.polio.label.customObrName',
        defaultMessage: 'Custom campaign name',
    },
    useCustomObrName: {
        id: 'iaso.polio.label.useCustomObrName',
        defaultMessage: 'Use custom campaign name',
    },
    ALL_ROUNDS_ON_HOLD: {
        id: 'iaso.polio.tooltip.label.ALL_ROUNDS_ON_HOLD',
        defaultMessage: 'All rounds of this campaign have been put on hold',
    },
    ROUND_ON_HOLD: {
        id: 'iaso.polio.tooltip.label.ROUND_ON_HOLD',
        defaultMessage: 'The attached round has been put on hold',
    },
    TEST_CAMPAIGN: {
        id: 'iaso.polio.tooltip.label.TEST_CAMPAIGN',
        defaultMessage: 'This campaign has been marked as test campaign',
    },
    CAMPAIGN_ON_HOLD: {
        id: 'iaso.polio.tooltip.label.CAMPAIGN_ON_HOLD',
        defaultMessage: 'This campaign has been put on hold',
    },
    roundsOnHold: {
        id: 'iaso.polio.tooltip.label.roundsOnHold',
        defaultMessage: 'The attached round(s) have been put on hold',
    },
    doses_per_vial: {
        id: 'iaso.polio.form.doses_per_vial',
        defaultMessage: 'Doses per vial',
    },
    temporary_form_a: {
        id: 'iaso.polio.form.temporary_form_a',
        defaultMessage: 'Temporary Form A',
    },
    temporary_status_change_title: {
        id: 'iaso.polio.form.temporary_status_change_title',
        defaultMessage: 'Change Form A status',
    },
    received_to_temporary_warning: {
        id: 'iaso.polio.form.received_to_temporary_warning',
        defaultMessage:
            'Changing this Form A back to temporary will remove the reception date and file on save.',
    },
    temporary_toggle_unsaved_warning: {
        id: 'iaso.polio.form.temporary_toggle_unsaved_warning',
        defaultMessage:
            'Switching back to temporary will discard the reception date and file you have entered.',
    },
    form_a_status: {
        id: 'iaso.polio.label.form_a_status',
        defaultMessage: 'Status',
    },
    form_a_status_temporary: {
        id: 'iaso.polio.label.form_a_status_temporary',
        defaultMessage: 'Temporary',
    },
    form_a_status_received: {
        id: 'iaso.polio.label.form_a_status_received',
        defaultMessage: 'Received',
    },
});

export default MESSAGES;
